// export const ENDPOINT = "http://69.169.101.31:5021/api/";
// export const WEB_URL = "http://69.169.101.31:5020/";
export const QR_URL = "http://pos.eskaiy.dev/";
export const QR_URL_R = "http://es.eskaiy.dev/";
export const IMAGEBASEURL = "https://fileserver.eskaiy.dev/CLOUD_SYSADMIN";

// export const ENDPOINT = "http://216.219.84.38:8686/api/";
// export const WEB_URL = "http://216.219.84.38:6565/";

export const ENDPOINT = "https://Api-sysadmin.eskaiy.dev/api/";
export const WEB_URL = "https://Sysadmin.eskaiy.dev/";